// src/component/AuthModals.jsx
import React, { useState } from "react";
import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";

const AuthModals = ({ showLogin, showRegister, onCloseLogin, onCloseRegister, openRegisterFromLogin, openLoginFromRegister,navigation=true }) => {
    return (
        <>
            <LoginModal
                show={showLogin}
                onClose={onCloseLogin}
                onRegisterClick={openRegisterFromLogin}
                navigation={navigation}
            />
            <RegisterModal
                show={showRegister}
                onClose={onCloseRegister}
                onLoginClick={openLoginFromRegister}
                navigation={navigation}
            />
        </>
    );
};

export default AuthModals;
